import { Card } from "react-bootstrap";
import FilePreview from "./FilePreview";

function NovaPanel({ novaError, checkingId, novaData, responses, selectedQuestionId }) {
    // const files = responses[selectedQuestionId]?.files || [];
    // const urls = responses[selectedQuestionId]?.file_urls || [];

    return (
        <Card className="nova_section text-light p-3">
            <h4 className="text-info mb-3 text-center">Nova</h4>

            {novaError && <div className="alert alert-danger">{novaError}</div>}

            <div className="nova_page_wraper">
                {checkingId && (
                    <>
                        <div className="shimmer-line mb-3"></div>
                        <div className="shimmer-line mb-3"></div>
                        <div className="shimmer-line mb-3"></div>
                    </>
                )}

                {/* {files.map((file, i) => (
                    <FilePreview key={i} file={file} url={urls[i]} />
                ))} */}

                {novaData && (
                    <div>
                        <h5 className="text-info">Decision</h5>
                        <p>{novaData?.evaluation?.decision}</p>

                        <h5 className="text-info">Summary</h5>
                        <p>{novaData?.evaluation?.summary}</p>

                        <h5 className="text-info">Violations</h5>
                        <ul>
                            {novaData?.evaluation?.violations?.map((v, i) => (
                                <li key={i}>{v}</li>
                            ))}
                        </ul>

                        <h5 className="text-info">Missing Evidence</h5>
                        <ul>
                            {novaData?.evaluation?.missing_evidence?.map((m, i) => (
                                <li key={i}>{m}</li>
                            ))}
                        </ul>

                        {/* <h5 className="text-info">File Summary</h5>
                        <p>{novaData?.file_summary}</p> */}
                    </div>
                )}
            </div>
        </Card>
    );
}

export default NovaPanel;
